module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }